<template>
  <b-alert variant="success" v-model="showAlert" dismissible> {{ successMessage }} </b-alert>
</template>

<script>
export default {
  props: {
    successMessage: {
      type: String
    },
    showAlert: {
      type: Boolean
    }
  }
}
</script>